<button
	[attr.tooltip-value]="'Show Anaglyph' | translate"
	tooltip-class="top"
	[disabled]="isDisabled"
	(click)="ShowAnaglyph()">
	<span class="indicator"></span>
	<span class="text">{{'Show Anaglyph' | translate}}</span>
</button>
